import React from "react";

import { useEffect, useState } from "react";
import { useOutletContext  ,useLocation,useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnUi from "Utils/MbpAthn";
import { isMobile } from "react-device-detect";
import EmlAthnModalUi from "Utils/EmlAthnModalUi";
import MembLvdRegApi from "Apis/MembLvdRegApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MgpStore from "Stores/Store";
import MdalCommUi from "Utils/MdalCommUi";
import { Helmet } from "react-helmet-async";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import ApiResultModal from "Components/ApiResultModal";
declare global {
    interface Window { kmcRespFunc: any; }
}

const AppMembLvdUi = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const currentLang = useSelector((state: any) => state.LangSetState?.Lang);
    
    const [emlAthnPrpsCd] =useState("MEMB_LVD");
    const [showEmlModal, setShowEmlModal] = useState(false);
    const [mdalState,setmdalState] = useState(false);
    const [ntcMdalState,setNtcMdalState] = useState(false);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
    const MdalOpenerFunc =(e:string|null) => {
        setmdalState(!mdalState);
    }
    const NtcMdalOpenerFunc =(e:string|null) => {
        setNtcMdalState(!ntcMdalState);
    }
    const EmlAthnPopFunc = (e:any)=>{
        if(chkState == false) {
            openResultModal(langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_00);
            return;
        }
        if (isMobile) {
            setShowEmlModal(true);
        } else {
            window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
        }
    }
    const [chkState,setChkState] = useState(false);
    const [lvdGUIDECtxtState,setLvdGUIDECtxtState] = useState();
    
    // 체크박스 확인 함수
    const checkboxValidation = () => {
        if(chkState == false) {
            openResultModal(langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_00);
            return true; // 체크가 안되어있으면 실행을 중단
        }
        return false; // 체크가 되어있으면 계속 진행
    }
    
    // emlAthnRespFunc를 컴포넌트 함수 내부에 정의하여 최신 상태에 접근
    const emlAthnRespFunc = () => {
        if(chkState == false) {
            openResultModal(langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_00);
            return;
        }
        MembLvdRegApi().then((resp)=>{
             switch(resp.apiHdr.code) {
                case "MEMB0000":
                        openResultModal(langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_01, 
                            () => navigate("/Connect/AppStrt",{state:{pageCd:"leaved"}, replace:true}));
                    break;
                default:                             
                openResultModal(`${resp.apiHdr.msg}`, );
                break;
            }
        });
    }
    
    useEffect(()=>{
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                MembLvdRegApi().then((resp)=>{
                    switch(resp.apiHdr.code) {
                        case "MEMB0000":
                                openResultModal(langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_01, 
                                    () => navigate("/Connect/AppStrt",{state:{pageCd:"leaved"}, replace:true}));
                            break;
                        default:                             
                        openResultModal(`${resp.apiHdr.msg}`, );
                        break;
                    }
                });
            });
        }

        window.kmcRespFunc = kmcRespFunc;
        window.emlAthnRespFunc = emlAthnRespFunc;

        return () => {
            try { window.kmcRespFunc = undefined; } catch (e) {}
            try { window.emlAthnRespFunc = undefined; } catch (e) {}
        };
    },[emlAthnRespFunc, navigate]);

    useEffect(()=>{
        EtcCtxtApi("CTNT_KIND_ETC","MEMB_LVD_GUIDE","MGP").then((resp)=>{
            
            if(resp.apiHdr.code === "COMM0000") {
                setLvdGUIDECtxtState(resp.apiBody.ctxt);
            }
        });
    },[currentLang])
    
    // 모달 상태에 따른 스크롤 제어 (헤더 제외)
    useEffect(() => {
        if (mdalState) {
            // 현재 스크롤바 너비 계산
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            // body만 스크롤 막기 + 패딩 추가
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        } else {
            // 모달이 닫히면 스크롤 복원 + 패딩 제거
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        }
        
        // 컴포넌트 언마운트 시 스크롤 복원
        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    }, [mdalState]);
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            app="app"
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MEMB_LVD_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MEMB_LVD_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="contaniner700">
                <div className="membLvdWrap">
                        <div className="membLvdTitlWrap">
                            <p className="membLvdPageDesc">{langData&&langData.MYPAGE_MEMB_LVD_PAGE_DESC_00}</p>
                        </div>
                        <div className="membLvdContentWrap">
                            { lvdGUIDECtxtState != null?
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: lvdGUIDECtxtState,
                                    }} className="membLvdCtxtWrap">
                                </div>
                                :
                                <></>
                            }
                        </div>
                        <div className="membLvdBtnWrap">
                            <div className="checkboxWrap">
                                <input type="checkbox" name="agreEmlNtfy"id='agreEmlNtfy' className="agreChkBox" onChange={()=>setChkState(!chkState)}/>
                                <label htmlFor="agreEmlNtfy">{langData&&langData.MYPAGE_MEMB_LVD_AGRE_BTN_00}</label>
                                {/* 회원 탈퇴 주의사항 확인 */}
                            </div>
                        </div>
                </div>
            </div>
            <div className="membLvdMbpAthnWrap loginInputWrap">

                <>
                    {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "EML"?
                        <>
                        <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=' + emlAthnPrpsCd + "&lang=" +MgpStore.getState().LangSetState.Lang}`)} className="loginBtn">
                            <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</span>
                            {/* 인증하기 */}
                        </button>
                        {showEmlModal && (
                            <EmlAthnModalUi
                                emlAthnPrpsCd={emlAthnPrpsCd}
                                onSuccess={(athnPrpsCd: string) => {
                                    setShowEmlModal(false);
                                    if (typeof window.emlAthnRespFunc === 'function') {
                                        window.emlAthnRespFunc(athnPrpsCd);
                                    }
                                }}
                                onClose={() => setShowEmlModal(false)}
                            />
                        )}
                        </>
                        :
                        <MbpAthnUi athnPrpsCd='MEMB_LVD' AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00} chkState={chkState} ChkFunc={checkboxValidation} BtnClass="loginBtn"/>
                    }
                </>

            </div>
        </div>
        {mdalState&&(
            <div className="mdalWrap dpstLpop mdalCommWrap">
                <div className="mdalBg" onClick={()=>MdalOpenerFunc(null)}></div>
                <div className="mdalCtxtWrap contaniner700 mdalCommContainer">
                    <div className="dpstLstMdalClose">
                        <button  className="mdalCloseBtn"onClick={() => MdalOpenerFunc(null)}>
                            <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                        </button>
                    </div>
                </div>
            </div>
        )}
         {ntcMdalState&& (
            <MdalCommUi 
                mdalType={""} 
                mdalCtxtTitl={`${langData&&langData.MYPAGE_MEMB_LVD_LPOP_DESC_00}`} 
                mdalSize={"w500"} 
                mdalFunc={() => NtcMdalOpenerFunc(null)} 
            />
            // MYPAGE_MEMB_LVD_LPOP_DESC_00
        )}
        </>
    )
}

export default AppMembLvdUi;